import _sfc_main from "./Swiper.vue2.mjs";
/* empty css             */
import normalizeComponent from "../../../_virtual/_plugin-vue2_normalizer.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { ref: "swiperRef", staticClass: "swiper" }, [_c("div", { staticClass: "swiper-item-container", style: _setup.swiperStyle, on: { "touchstart": _setup.handleTouchStart, "touchmove": _setup.handleTouchMoveThrottle, "touchend": _setup.handleTouchEnd } }, [_setup.swiperMounted ? _vm._t("default") : _vm._e()], 2), _setup.swiperItemNumber > 1 ? _c("div", { staticClass: "swiper-dot-container" }, _vm._l(_setup.swiperItemNumber, function(item, index) {
    return _c("div", { key: item, staticClass: "swiper-dots", class: [_setup.isActiveDot(index) ? "swiper-current-dots" : ""] });
  }), 0) : _vm._e()]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "8b76ba67"
);
const TuiSwiper = __component__.exports;
export {
  TuiSwiper as default
};
